import { render, staticRenderFns } from "./CostBearerPaymentsByStudentEducation.vue?vue&type=template&id=690a3476&"
import script from "./CostBearerPaymentsByStudentEducation.vue?vue&type=script&lang=ts&"
export * from "./CostBearerPaymentsByStudentEducation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports